<template>
  <div class="learning-banner sajilo-section bottom-arrow-presentation arrow-left">
      <span class="icon-arrow-right-group"></span>
    <div class="container">
      <v-row class="align-center">
        <v-col md="12" lg="4" xl="3">
          <article class="learning-banner__headarticle">
            <div class="sajilo-section__title learning-banner__title">
              Keep Learning
            </div>
            <div class="sajilo-section__text learning-banner__text">
              Wherever you are. However you want.
            </div>
          </article>
        </v-col>
        <v-col md="12" lg="8" xl="9">
          <div class="learning-banner__content d-flex justify-space-between">
            <div class="learning-banner__item">
              <button type="button" class="trust_orange_button">
                <v-icon> mdi-school </v-icon>
                <span> 900+ Students </span>
              </button>
            </div>
            <div class="learning-banner__item">
              <button type="button" class="trust_purple_button">
                <v-icon> mdi-clock-outline </v-icon>
                <span> 24*7 Availability </span>
              </button>
            </div>
            <div class="learning-banner__item">
              <button type="button" class="trust_purple_button">
                <v-icon> mdi-teach </v-icon>
                <span> 200+ Instructors </span>
              </button>
            </div>
            <div class="learning-banner__item">
              <button type="button" class="trust_orange_button">
                <v-icon> mdi-book-open-page-variant </v-icon>
                <span> 15000+ Courses </span>
              </button>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
    name: 'KeepLearning'
};
</script>